import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Storage } from "aws-amplify";
import "./Services.css";

const SERVICE_S3_KEYS = [
  "portfolio/steps/steps_lg00015.jpeg",
  "portfolio/pavers/pavers00001.jpeg",
  "portfolio/concrete/concrete_lg_00008.jpeg",
  "portfolio/retaining/retaininig_lg00006.jpeg",
];

function useServiceImages() {
  const [urls, setUrls] = useState({});
  useEffect(() => {
    Promise.all(
      SERVICE_S3_KEYS.map(async (key) => {
        try {
          return [key, await Storage.get(key)];
        } catch { return [key, null]; }
      })
    ).then((entries) => setUrls(Object.fromEntries(entries)));
  }, []);
  return urls;
}

const serviceData = [
  {
    id: 1,
    title: "BRICK STEPS",
    subtitle: "Entryway Excellence",
    s3Key: SERVICE_S3_KEYS[0],
    description: "Polania Construction is the leading expert in brick step construction. Our skilled masons have been providing top-quality brick step services for over 30 years, and have a rich history of delivering only the best work to our customers.",
    details: [
      "Custom designs to match your home's architecture",
      "Premium brick and mortar selection",
      "Proper foundation and drainage consideration",
      "30+ year durability guarantee",
      "Weather-resistant construction techniques"
    ],
    features: ["Custom Design", "30+ Year Durability", "Weather Resistant", "Heritage Techniques"]
  },
  {
    id: 2,
    title: "PAVER INSTALLATION",
    subtitle: "Patios & Driveways",
    s3Key: SERVICE_S3_KEYS[1],
    description: "Polania Construction is the premier choice for all your paver needs. Our experienced installers deliver quality and craftsmanship in every project, from elegant patios to stunning driveways.",
    details: [
      "Wide variety of paver styles and materials",
      "Precision grading and base preparation",
      "Proper drainage integration",
      "Pattern design consultation",
      "Long-lasting edge restraints"
    ],
    features: ["Premium Materials", "Perfect Grading", "Custom Patterns", "Lifetime Warranty"]
  },
  {
    id: 3,
    title: "CONCRETE WORK",
    subtitle: "Foundation of Quality",
    s3Key: SERVICE_S3_KEYS[2],
    description: "Polania Construction provides highest quality concrete work for both residential and commercial projects. We understand the importance of customer satisfaction and deliver strength and beauty in every pour.",
    details: [
      "Sidewalks and driveways",
      "Stamped and decorative concrete",
      "Foundation work",
      "Proper reinforcement techniques",
      "Crack-resistant formulations"
    ],
    features: ["Stamped Options", "Reinforced", "Crack Resistant", "Decorative Finishes"]
  },
  {
    id: 4,
    title: "RETAINING WALLS",
    subtitle: "Structural Artistry",
    s3Key: SERVICE_S3_KEYS[3],
    description: "Polania Construction is the trusted choice for all your retaining wall needs, delivering both strength and aesthetic appeal to your landscape. We engineer solutions that prevent erosion while enhancing beauty.",
    details: [
      "Proper engineering and load calculations",
      "Multiple material options",
      "Integrated drainage systems",
      "Erosion prevention",
      "Landscape integration"
    ],
    features: ["Expert Engineering", "Natural Stone", "Drainage Systems", "Erosion Control"]
  }
];

export default function Services() {
  const imageUrls = useServiceImages();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      {/* Hero */}
      <section className="services-hero">
        <div className="services-hero-bg"></div>
        <div className="services-hero-content">
          <span className="hero-label">WHAT WE DO</span>
          <h1 className="hero-title">
            OUR <span className="gold-text">SERVICES</span>
          </h1>
          <p className="hero-description">
            We specialize in concrete and stone masonry for residential and
            commercial complexes. With 40+ years of experience, we pride ourselves
            in providing high-quality work and excellent customer service.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="services-list">
        {serviceData.map((service, index) => (
          <div
            key={service.id}
            className={`service-detail ${index % 2 === 1 ? 'reverse' : ''}`}
          >
            <div className="service-image">
              {imageUrls[service.s3Key] && <img src={imageUrls[service.s3Key]} alt={service.title} />}
              <div className="service-number">0{service.id}</div>
            </div>
            <div className="service-content">
              <span className="service-subtitle">{service.subtitle}</span>
              <h2 className="service-title">{service.title}</h2>
              <p className="service-description">{service.description}</p>
              
              <div className="service-details">
                <h4>What We Offer:</h4>
                <ul>
                  {service.details.map((detail, i) => (
                    <li key={i}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="service-features">
                {service.features.map((feature, i) => (
                  <span key={i} className="feature-tag">{feature}</span>
                ))}
              </div>

              <Link to="/estimate" className="btn-primary service-cta">
                GET QUOTE FOR {service.title}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </section>

      {/* Additional Services */}
      <section className="additional-services">
        <div className="services-container">
          <h2 className="section-title">
            ADDITIONAL <span className="gold-text">SERVICES</span>
          </h2>
          <div className="additional-grid">
            <div className="additional-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <h3>Drainage Solutions</h3>
              <p>Proper water management to protect your investment</p>
            </div>
            <div className="additional-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                <line x1="3" y1="9" x2="21" y2="9"/>
                <line x1="9" y1="21" x2="9" y2="9"/>
              </svg>
              <h3>Stone Work</h3>
              <p>Natural stone installations and veneers</p>
            </div>
            <div className="additional-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              <h3>Brick Work</h3>
              <p>Traditional brick construction and repair</p>
            </div>
            <div className="additional-item">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                <line x1="9" y1="9" x2="9.01" y2="9"/>
                <line x1="15" y1="9" x2="15.01" y2="9"/>
              </svg>
              <h3>Consultation</h3>
              <p>Expert advice on your masonry projects</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="services-cta-section">
        <div className="services-container">
          <div className="cta-content">
            <h2>READY TO GET STARTED?</h2>
            <p>Contact us today for a free, no-obligation estimate</p>
            <div className="cta-buttons">
              <Link to="/estimate" className="btn-primary">
                GET FREE ESTIMATE
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
              <a href="tel:7322050086" className="btn-outline">
                CALL (732) 205-0086
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
